import React from 'react';

const money = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export default function CartPanel({
  carrito,
  unidades,
  total,
  onIncrease,
  onDecrease,
  onRemove,
  onClear,
  onPay,
}) {
  return (
    <aside className="flex h-[calc(100vh-118px)] min-h-[480px] flex-col overflow-hidden rounded-2xl bg-blanco-puro shadow-2xl">
      <div className="flex shrink-0 items-center justify-between border-b border-slate-200 px-4 py-3">
        <div className="flex items-baseline gap-2">
          <h2 className="text-base font-bold text-azul-oscuro">
            Venta actual
          </h2>

          <span className="text-[11px] text-slate-500">
            {unidades} {unidades === 1 ? 'unidad' : 'unidades'}
          </span>
        </div>

        {carrito.length > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="text-[11px] font-semibold text-red-600 hover:text-red-700"
          >
            Vaciar
          </button>
        )}
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto">
        {carrito.length === 0 ? (
          <div className="flex h-full flex-col items-center justify-center px-6 text-center">
            <div className="grid h-11 w-11 place-items-center rounded-full bg-azul-lago/10 text-2xl text-azul-lago">
              +
            </div>

            <strong className="mt-3 text-sm text-azul-oscuro">
              Venta vacía
            </strong>

            <span className="mt-1 text-xs text-slate-500">
              Buscá o escaneá el primer producto.
            </span>
          </div>
        ) : (
          carrito.map((item) => (
            <div
              key={item.id}
              className="border-b border-slate-100 px-4 py-2"
            >
              <div className="grid grid-cols-[minmax(0,1fr)_auto_auto_auto] items-center gap-3">
                <div className="min-w-0">
                  <strong className="block truncate text-[13px] font-semibold leading-tight text-azul-oscuro">
                    {item.nombre}
                  </strong>

                  <span className="text-[10px] text-slate-500">
                    {money(item.precio)} c/u
                  </span>
                </div>

                <div className="flex overflow-hidden rounded-md border border-slate-300">
                  <button
                    type="button"
                    onClick={() => onDecrease(item.id)}
                    className="h-7 w-7 bg-slate-50 text-sm hover:bg-slate-100"
                  >
                    −
                  </button>

                  <div className="grid min-w-[30px] place-items-center text-xs font-bold text-azul-oscuro">
                    {item.cantidad}
                  </div>

                  <button
                    type="button"
                    onClick={() => onIncrease(item.id)}
                    className="h-7 w-7 bg-slate-50 text-sm hover:bg-slate-100"
                  >
                    +
                  </button>
                </div>

                <strong className="min-w-[74px] text-right text-sm text-azul-oscuro">
                  {money(Number(item.precio) * item.cantidad)}
                </strong>

                <button
                  type="button"
                  onClick={() => onRemove(item.id)}
                  className="text-base leading-none text-slate-400 hover:text-red-600"
                  aria-label={`Quitar ${item.nombre}`}
                >
                  ×
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="shrink-0 border-t border-slate-200 bg-white px-4 py-3 shadow-[0_-8px_20px_rgba(15,23,42,0.06)]">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-sm text-slate-600">
            Total
          </span>

          <strong className="text-2xl font-bold text-azul-oscuro">
            {money(total)}
          </strong>
        </div>

        <button
          type="button"
          disabled={!carrito.length}
          onClick={onPay}
          className="flex h-11 w-full items-center justify-between rounded-xl bg-verde-esmeralda px-5 font-bold text-white shadow-lg transition hover:bg-verde-oscuro disabled:cursor-not-allowed disabled:opacity-40"
        >
          <span>Cobrar</span>

          <span className="text-[10px] font-medium opacity-80">
            Ctrl + Enter
          </span>
        </button>
      </div>
    </aside>
  );
}
